<template>
	<div v-if="token">
		<div v-if="questionStep">
			<span class="text-center">{{ $t('telemedcare.is-first-access') }}</span>
			<div class="row mt-4">
				<div class="col">
					<b-button class="w-100" variant="outline-primary" @click="showGuidedSteps">{{ $t('yes') }}</b-button>
				</div>
				<div class="col">
					<b-button class="w-100" variant="outline-primary" @click="showGuidedSteps($event, true)">No</b-button>
				</div>
			</div>
		</div>
		<div v-else>
			<div v-if="!appIsInstalled">
				<p v-html="$t('telemedcare.association.step-1')"></p>
				<div class="full-center mb-4">
					<a href="https://play.google.com/store/apps/details?id=com.app_tmc&hl=es&gl=US" target="_blank"><img class="app-store-btn" :src="$t('button.get-on-google-play')"/></a>
					<a href="https://apps.apple.com/us/app/tmc-blue/id1549501043?app=itunes&ign-mpt=uo%3D4" target="_blank"><img class="app-store-btn" :src="$t('button.get-on-app-store')"/></a>
				</div>
				<p v-html="$t('telemedcare.association.step-2', { step: '2' })"></p>
				<div class="container full-center mb-4">
					<qrcode-vue :size="size" :value="value" level="H"></qrcode-vue>
				</div>
			</div>
			<div v-else>
				<p v-html="$t('telemedcare.association.step-2-installed', { step: '1' })"></p>
			</div>
			<p v-html="$t('telemedcare.association.step-3', { step: appIsInstalled ? '2' : '3' })"></p>
			<p v-html="$t('telemedcare.association.step-4', { step: appIsInstalled ? '3' : '4' })"></p>
			<p v-html="$t('telemedcare.association.step-5', { step: appIsInstalled ? '4' : '5' })"></p>
			<p v-html="$t('telemedcare.association.clinic-history')"></p>
			<div class="full-center">
				<b-button variant="primary" @click="$helpers.goToPatientWebApp('history')" target="_blank">{{ $t('telemedcare.access-portal') }}</b-button>
			</div>
				<p></p>
			</div>
		</div>
	<div v-else>
		<p>{{ $t('telemedcare.no-tmc-token-found') }}</p>
		<div>
			<b-button variant="primary" v-b-modal.tmc-modal-login-form>{{ $t('log-in') }}</b-button>
		</div>
		<b-modal id="tmc-modal-login-form" centered hide-footer>
			<template #modal-title>
				{{$t('log-in')}}
			</template>
			<login-form :loginUrl="$helpers.getUrlFromAxiosInstance($tmcApi, 'Login')" :loginCallback="loginCallback"></login-form>
		</b-modal>
		<b-modal>
			
		</b-modal>
	</div>
</template>
<script>
import QrcodeVue from 'qrcode.vue'
import { BButton, BModal } from 'bootstrap-vue'
import { inMx } from '@/helpers/global.helpers'

export default {
  components: {
    QrcodeVue,
		'login-form': () => import('@/components/forms/LoginForm'),
		BButton,
		BModal
  },
  name: 'qr-code',
  data () {
    return {
			questionStep: true,
      endpoint: !inMx ? 'https://gdp-api-eu.telemedcare.com' : 'https://api-us.telemedcare.com',
      token: window.$cookies.get('tmc_token'),
      size: 200,
			appIsInstalled: false
    }
  },
	computed: {
		value () {
			return JSON.stringify({
				endPoint: this.endpoint,
				token: this.token
			})
		}
		/* goToClinicHistory () {
			this.$helpers.goToPatientWebApp('history')
		} */
		/* getSSOLoginUrl () {
			/* return `https://portal-eu.telemedcare.com/#uid=${this.token}` */
			/* return this.$helpers.goToPatientWebApp('history')
		} */
	},
	methods: {
		showGuidedSteps (event, appIsInstalled = false) {
			this.questionStep = false
			this.showGuidedSteps = true
			this.appIsInstalled = appIsInstalled
		},
		loginCallback (response) {
			if (response.data.statusCode === 200) {
				window.$cookies.set('tmc_token', response.data.result.userLogged.token)
			}
			location.reload()
		},
		goToClinicHistory () {
			this.$helpers.goToPatientWebApp('history')
		}
	}
}
</script>

<style lang="scss">
	body {
		overflow: initial !important;
	}
	
	.full-center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.app-store-btn {
		max-width: 200px;

		@include mobile {
			max-width: 150px;
		}
	}

</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/health/TMCQrCodeContainer.vue